import { render, staticRenderFns } from "./GradeModal.vue?vue&type=template&id=59838e58&scoped=true&"
import script from "@/scripts/QA/Question/components/GradeModal?vue&type=script&lang=js&"
export * from "@/scripts/QA/Question/components/GradeModal?vue&type=script&lang=js&"
import style0 from "./GradeModal.vue?vue&type=style&index=0&id=59838e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59838e58",
  null
  
)

export default component.exports